import React from "react"
import TickethossLogo from "../../images/ticketHossLogo.svg"
import PitpayLogo from "../../images/Pit Pay Orange .svg"
import Button from "../Button"
import Qr from "../../images/qr_icon.svg"
import TicketAccordion from "./TicketAccordion"
import {
  SideMenu,
  Background,
  BodyContainer,
  LogoContainer,
  TickethossLogoContainer,
  CloseWrapper,
  BuyTicketContainer,
  BuyTicketMobileButton,
  AccordionContainer,
  TicketTextHeader,
  CloseButton,
} from "../../styles/trackTickets.style"
import TicketList from "./TicketList"
import Close from "../../images/close.svg"
import CloseWhite from "../../images/close_white.svg"

export default function TrackTickets({
  open,
  toggleTicketModal,
  openOption,
  setOpenOption,
  deepLink,
  tickets,
  isEvent,
  openDownloadModal,
  name,
}) {
  const appLink = process.env.GATSBY_EXTERNAL_URL
  const isTickethoss = process.env.GATSBY_APP_PLATFORM === "tickethoss"

  return (
    <>
      <Background
        role="menu"
        className={`${open ? " active" : ""}`}
        onClick={toggleTicketModal}
        onKeyDown={event => {
          // insert your preferred method for detecting the keypress
          if (event.keycode === 13) toggleTicketModal()
        }}
      ></Background>
      {open ? (
        <CloseButton
          onClick={toggleTicketModal}
          src={CloseWhite}
          alt="Close Icon"
        />
      ) : null}
      <SideMenu className={`${open ? " active" : ""}`}>
        <CloseWrapper
          onClick={toggleTicketModal}
          src={Close}
          alt="Close Icon"
          width={35}
          height={35}
        />
        <BodyContainer>
          <LogoContainer>
            <TickethossLogoContainer
              src={isTickethoss ? TickethossLogo : PitpayLogo}
              alt="Tickethoss Logo"
            />
            <div className="Col">
              <BuyTicketContainer>
                <Button
                  text="To Purchase Download the App"
                  style={{ maxWidth: 373, width: "100%", fontSize: "1.5em" }}
                  onClick={openDownloadModal}
                />
              </BuyTicketContainer>
            </div>
            <BuyTicketMobileButton>
              <a href={appLink} target="_blank" rel="noreferrer">
                <Button
                  text="To Purchase Download the App"
                  style={{
                    maxWidth: 311,
                    width: "100%",
                    fontSize: "1.5em",
                    lineHeight: "34px",
                  }}
                />
              </a>
            </BuyTicketMobileButton>
          </LogoContainer>

          <AccordionContainer>
            <TicketTextHeader>
              {name ? name : isTickethoss ? "TICKETS" : "Pit Passes"}
            </TicketTextHeader>
            {tickets?.map(ticketOption =>
              !isEvent ? (
                <TicketAccordion
                  key={ticketOption.type.id}
                  id={ticketOption.type.id}
                  icon={Qr}
                  name={ticketOption.type.name}
                  background="#FA4616"
                  iconColor="white"
                  isTicket={true}
                  openOption={openOption}
                  tickets={ticketOption.tickets}
                  deepLink={deepLink}
                  setOpenOption={setOpenOption}
                  openDownloadModal={openDownloadModal}
                />
              ) : (
                <TicketList
                  deepLink={deepLink}
                  ticket={ticketOption}
                  key={ticketOption.id}
                  openDownloadModal={openDownloadModal}
                />
              )
            )}
          </AccordionContainer>
        </BodyContainer>
      </SideMenu>
    </>
  )
}
